import { ShieldSunOutlineIcon } from './ShieldSunOutlineIcon';

/**
 * author: Perth Totty
 * id 36B9C70C-5576-459A-AF44-A8E8F97B5DA8
 * name shield-sun-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-sun-outline.svg
 * tags
 * - Weather 
 */
export const SunProtectionOutlineIcon = ShieldSunOutlineIcon;
export default SunProtectionOutlineIcon